export default {
  rootURL: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/",
  eezURL: "MOW_OECS_Model_Reference_Layers_04072021_WFL1/FeatureServer/8"
};